export default __webpack_public_path__ + "static/media/khushi.8d784301.jpg";